import { useCallback, useEffect } from 'react';

import { removeJWTFromLocalStorage } from './jwt';
import { heapTrackExitPromptDisplayed } from './logging';

export const useExitPrompt = (
  message: string,
  shouldPrompt: boolean,
  signOutClicked?: boolean,
  onTrigger?: () => void,
  trackTrigger?: () => void
) => {
  const unloadListener = useCallback(() => {
    removeJWTFromLocalStorage();
  }, []);
  useEffect(() => {
    const beforeUnloadListener = (e: BeforeUnloadEvent) => {
      if (signOutClicked) {
        window.addEventListener('unload', unloadListener);
      } else {
        window.removeEventListener('unload', unloadListener);
      }
      if (onTrigger) {
        onTrigger();
      }
      // Track Variant group upon showing the exit prompt
      heapTrackExitPromptDisplayed(true);
      if (trackTrigger) trackTrigger();
      e.preventDefault();
      e.returnValue = message;
      return e;
    };

    // if the consumer requests the prompt to show
    if (shouldPrompt) {
      // add the beforeunload listener
      window.addEventListener('beforeunload', beforeUnloadListener);
    } else {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    }
    // always clean up the beforeunload listener
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadListener);
    };
  }, [shouldPrompt, signOutClicked]);
};

useExitPrompt.defaultProps = {
  signOutClicked: false,
  onTrigger: undefined,
  trackTrigger: undefined,
};
